let helloworld = 'helloworld';
let OVERVIEW = 'ダッシュボード';

export default { OVERVIEW, helloworld };
